<app-header *ngIf="showHeader$ | async"></app-header>
<div class="main-view-container">
  <router-outlet (activate)="scrollToTop()"></router-outlet>
  <app-spinner></app-spinner>
</div>
<app-confirm-cookie></app-confirm-cookie>
<app-footer></app-footer>
